import * as THREE from 'three';

export class GuardRail{
	//height：距离地面高度，startStake：分隔带起始桩号， endStake：分隔带终止桩号，roadStakes:道路桩数据，dividerType：分隔带类型
	constructor(height, startStake, endStake, roadStakes,guardRailType){
		this.height = height;
		this.guradRailType = guardRailType;
		this.startStake = startStake;
		this.endStake = endStake;
		this.roadStakes = roadStakes;
	}
}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/models/GuardRail.js